export const FlagFR = ({ className = "" }) => (
  <svg viewBox="0 0 24 16" className={className} aria-hidden="true">
    <rect width="24" height="16" fill="#fff" />
    <rect width="8" height="16" fill="#002654" />
    <rect x="16" width="8" height="16" fill="#CE1126" />
    <rect width="24" height="16" fill="none" stroke="rgba(0,0,0,0.15)" strokeWidth="1" />
  </svg>
);

export const FlagEN = ({ className = "" }) => (
  <svg viewBox="0 0 24 16" className={className} aria-hidden="true">
    <rect width="24" height="16" fill="#012169" />
    <path d="M0 0l24 16M24 0L0 16" stroke="#fff" strokeWidth="3.2" />
    <path d="M0 0l24 16M24 0L0 16" stroke="#C8102E" strokeWidth="1.8" />
    <path d="M12 0v16M0 8h24" stroke="#fff" strokeWidth="5.4" />
    <path d="M12 0v16M0 8h24" stroke="#C8102E" strokeWidth="3.2" />
    <rect width="24" height="16" fill="none" stroke="rgba(0,0,0,0.15)" strokeWidth="1" />
  </svg>
);

export const FLAGS = { fr: FlagFR, en: FlagEN };
